import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api/axios'
import type { Workforce } from './logic'

/**
 * The supply side, in one call.
 *
 * All three new views read this same query key, so they cannot disagree with each other about how
 * many engineers are on a site — a per-view fetch would let two panels on one screen show
 * different numbers for the same fact.
 */
/**
 * `requestID` narrows the SITE DEMAND only — the engineer roster stays estate-wide, because who
 * exists and where they are does not change with a filter. It is part of the query key, so the
 * scoped and unscoped answers cannot overwrite each other in the cache.
 */
export function useWorkforce(enabled = true, requestID?: string | null) {
  return useQuery({
    queryKey: ['assignment-workforce', requestID || null],
    queryFn: () => api
      .get<{ data: Workforce }>('/api/assignment-workforce', {
        params: requestID ? { requestID } : undefined,
      })
      .then((r) => r.data.data),
    enabled,
    staleTime: 30_000,
  })
}
